<!-- white-block template -->
<template>
  <section class="media" style="padding: 0">
    <div class="category_container" style="position: relative">
      <div class="cotegory_list_wap">
        <div class="category_list">
          <ul>
            <li>
              <a :href="item.cateUrl + 'top5.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                  alt=""
                />
                <span>総合大賞</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'new-face.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-new-face.svg"
                  alt=""
                />
                <span>新人賞</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="category_media_list">
          <span class="category_subtitle_style">メディア賞</span>
          <ul class="category_media_list_ul">
            <li>
              <a :href="item.cateUrl + 'news.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-news.svg"
                  alt=""
                />
                <span>MAG2NEWS賞</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'money.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-money.svg"
                  alt=""
                />
                <span>MONEY VOICE賞</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'tripeditor.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-tripeditor.svg"
                  alt=""
                />
                <span>TRiP EDiTOR賞</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'bythem.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-tripeditor.svg"
                  alt=""
                />
                <span>by them賞</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="category_category_list">
          <span class="category_subtitle_style">部門別賞</span>
          <ul>
            <li>
              <a :href="item.cateUrl + 'business.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-business.svg"
                  alt=""
                />
                <span>ビジネス</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'news-commentary.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-news-commentary.svg"
                  alt=""
                />
                <span>時事解説</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'journalism.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-journalism.svg"
                  alt=""
                />
                <span>ジャーナリズム</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'specialty.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-specialty.svg"
                  alt=""
                />
                <span>専門情報</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'political.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-political.svg"
                  alt=""
                />
                <span>政治経済</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'management.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-management.svg"
                  alt=""
                />
                <span>起業・経営</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'career.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-career.svg"
                  alt=""
                />
                <span>キャリアアップ</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'asset-stock.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-asset-stock.svg"
                  alt=""
                />
                <span>資産運用&nbsp;(株式)</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'asset-fx.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-asset-fx.svg"
                  alt=""
                />
                <span>資産運用&nbsp;(FX･先物･債券)</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'asset-es.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-asset-es.svg"
                  alt=""
                />
                <span>資産運用&nbsp;(不動産)</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'knowledge.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-knowledge.svg"
                  alt=""
                />
                <span>知識・ノウハウ</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'psychology.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-psychology.svg"
                  alt=""
                />
                <span>こころ</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'self-developement.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-self-developement.svg"
                  alt=""
                />
                <span>自分磨き</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'mental-training.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-mental-training.svg"
                  alt=""
                />
                <span>メンタルトレーニング</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'safety.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-safety.svg"
                  alt=""
                />
                <span>安全・防災</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'language.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-language.svg"
                  alt=""
                />
                <span>語学</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'education.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-education.svg"
                  alt=""
                />
                <span>教育</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'hobby.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-hobby.svg"
                  alt=""
                />
                <span>趣味・娯楽</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'column.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-column.svg"
                  alt=""
                />
                <span>コラム</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'life.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-life.svg"
                  alt=""
                />
                <span>生活</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'love.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-love.svg"
                  alt=""
                />
                <span>恋愛</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'health.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-health.svg"
                  alt=""
                />
                <span>健康</span>
              </a>
            </li>
            <li>
              <a :href="item.cateUrl + 'entertainment.html'">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-entertainment.svg"
                  alt=""
                />
                <span>エンタメ</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      ActiveBtn: false
    }
  }
}
</script>

<style scoped>
/* カテゴリーボタン */
.media {
  margin-top: 80px;
}
.category_container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.cotegory_list_wap {
  width: 100%;
  margin: 0 auto;
}
.category_list,
.category_media_list,
.category_category_list {
  margin: 0 0 40px;
  width: 100%;
  text-align: center;
}
.category_list span,
.category_media_list span,
.category_category_list span {
  font-family: 游ゴシック体, YuGothic, 'ヒラギノ角ゴ ProN W3',
    'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic', メイリオ, Meiryo,
    sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
}

.category_list ul,
.category_media_list ul,
.category_category_list ul {
  margin: 0 auto 36px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0;
}

.category_list ul {
  margin: 10px auto 0;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
}

.category_list ul li,
.category_media_list ul li,
.category_category_list ul li {
  width: calc(33% - 5px);
  box-sizing: border-box;
  margin: 10px 6px 0 0;
  display: block;
}

.category_list ul li {
  margin: 7px auto;
  width: 100%;
}

.category_media_list_ul li{
    width: calc((100% / 2) - 10px)!important;
    margin: 10px auto!important;
}

.category_list ul li a,
.category_media_list ul li a,
.category_category_list ul li a {
  width: 100%;
  max-width: 390px;
  margin: 0 auto;
  padding: 8px;
  border: 1px solid #c4b580;
  background: rgba(256, 256, 256, 0.6);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0s;
}

.category_list ul li a span,
.category_media_list ul li a span,
.category_category_list ul li a span {
  color: #222;
  text-decoration: none;
}

.category_list ul li a:hover,
.category_media_list ul li a:hover,
.category_category_list ul li a:hover {
  background: #e0c97d;
  border: 1px solid #c4b580;
  border-radius: 6px;
  color: #222222;
  opacity: 1;
  text-decoration: none;
}

.category_list ul li a:hover span,
.category_media_list ul li a:hover span,
.category_category_list ul li a:hover span {
  color: #222;
  text-decoration: none;
}

.category_list ul li a img,
.category_media_list ul li a img,
.category_category_list ul li a img {
  width: 100%;
  max-width: 26px;
  height: auto;
  margin-right: 10px;
}
.category_subtitle_style {
  font-weight: bold !important;
  font-size: 22px !important;
  margin: 0 0 20px;
  display: block;
}
@media screen and (max-width: 400px) {
  .category_media_list_ul li{
    width: 100%!important;
  }
}
</style>
